import React from 'react';

import { PromoDetailMobileSkeleton } from '@atlas/ui';

const PromotionDetailsSkeleton = ({ children, loading }) => {
  if (loading) {
    return <PromoDetailMobileSkeleton />;
  }

  return children;
};

export default PromotionDetailsSkeleton;
